import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import { AktuelleStation } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/components/RotationsplanCard/AktuelleStation';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/components/RotationsplanCard/Mitarbeiter';
import { Qualifikationen } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/components/RotationsplanCard/Qualifikationen';
import { useState } from 'react';

export function RotationsplanCard({
  rotationsplan,
}: {
  rotationsplan: Rotationsplan;
}) {
  const [cardElement, setCardElement] = useState<HTMLDivElement | null>(null);

  return (
    <div
      ref={setCardElement}
      className="@container w-full h-full min-h-49 min-w-0 overflow-hidden bg-backgrounds-primary rounded-xl p-4 flex flex-col justify-between gap-4">
      <div className="flex flex-col gap-4">
        <Mitarbeiter rotationsplan={rotationsplan} cardElement={cardElement} />
        <AktuelleStation rotationsplan={rotationsplan} />
      </div>
      <Qualifikationen
        rotationsplan={rotationsplan}
        cardElement={cardElement}
      />
    </div>
  );
}
